import React from "react";

function SecurityTraining() {
  return (
    <div>
      <div class="Thumbnail"></div>
      <div class="ThumbnailMargin"></div>

      <div class="contentAfter col-md-10 mt-5 mb-5 p-2 ms-auto me-auto">
        <div class="text-center mb-5 w-full mx-auto">
          <span class="text-hollow text-transparent">
            Security Training & Awareness Program
          </span>
        </div>
        <p>
          Apart from offering security solutions to help your business rise like
          a Phoenix, Cyphinix provides training and awareness programs to help
          your business and employees learn more about cybercrimes which will
          help your business deal effectively and efficiently with cyber issues.
        </p>
        <p>
          The sub-services we offer in security training and awareness programs
          are corporate training, cyber security workshop, digital safety and
          awareness program, security simulation lab practices, and competitive
          hacking challenges.
        </p>
        <div class="row">
          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Corporate Training</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Training and development play a crucial role in empowering
                    the employees with new knowledge and skills.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Cyber Security Workshop</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Cyphinix offers workshops on Cyber security to teach you the
                    methods for identifying and tackling various types of cyber
                    hurdles.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Digital Safety and Awareness Program</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Learning how to stay safe digitally can constrain the spread
                    of cyber problems before reaching us. Therefore, the
                    knowledge of digital safety spread through awareness
                    programs is proven helpful.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Security Simulation Lab Practises</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Security simulation lab practices help us uncover the
                    effectiveness of the present security system by identifying
                    its efficiency in dealing with a controlled attack done
                    purposefully to test the security system.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Competitive Hacking Challenges (CTF)</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Competitive hacking challenges are a fun and great way to
                    enhance hacking skills and tricks. Apart from that, these
                    challenges can be proven enlightening as these can help us
                    discover the level to which we can tackle real-life hacking
                    problems.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SecurityTraining;
